import React, { useState } from 'react';
import './ProductImageGallery.css';

interface ProductImageGalleryProps {
  images: string[];
  altText: string;
}

const ProductImageGallery: React.FC<ProductImageGalleryProps> = ({ images, altText }) => {
  const [selectedImage, setSelectedImage] = useState(0);

  const getImageUrl = (index: number) => {
    const image = images[index];
    return image ? `https://api.flooron.in/${image}` : '/placeholder-product.png';
  };

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = '/placeholder-product.png';
  };

  if (!images || images.length === 0) return null;

  return (
    <div className="modern-gallery-wrapper">
      {/* Sidebar Thumbnails - Hidden on mobile, scrollable on desktop */}
      {images.length > 1 && (
        <div className="gallery-sidebar">
          {images.map((_, index) => (
            <button
              key={index}
              className={`thumb-btn ${selectedImage === index ? 'is-active' : ''}`}
              onClick={() => setSelectedImage(index)}
              onMouseEnter={() => setSelectedImage(index)} // Previews on hover for premium feel
            >
              <img 
                src={getImageUrl(index)} 
                alt={`Thumbnail ${index + 1}`} 
                onError={handleImageError}
              />
            </button>
          ))}
        </div>
      )}

      {/* Main Feature Display */}
      <div className="gallery-main">
        <div className="main-stage">
          <img
            src={getImageUrl(selectedImage)}
            alt={altText}
            className="stage-image"
            onError={handleImageError}
            key={selectedImage} // Triggers animation on change
          />
        </div>
        
        {/* Mobile Indicator Dots */}
        {images.length > 1 && (
          <div className="mobile-dots">
            {images.map((_, index) => (
              <span 
                key={index} 
                className={`dot ${selectedImage === index ? 'active' : ''}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductImageGallery;